<template>
    <b-container>
        <h1 class="mt-4">Stick It On Admin</h1>
        <b-row>
            <b-button to="/admin/requests" class="w-25 mt-4" variant="default" lg block>View Requests</b-button>
        </b-row>
        <b-row>
            <b-button to="/admin/tracks" class="w-25 mt-4" variant="default" lg block>View Tracks</b-button>
        </b-row>
        <b-row>
            <b-button to="/admin/playlists" class="w-25 mt-4" variant="default" lg block>View Playlists</b-button>
        </b-row>
        <b-row>
            <b-button to="/admin/signage" class="w-25 mt-4" variant="default" lg block>Launch Signage</b-button>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "AdminLanding"
    }
</script>

<style scoped>

</style>
